import { render } from "./premium-reward.html?vue&type=template&id=5b0d4c1d&ts=true"
import script from "./premium-reward.vue?vue&type=script&lang=ts"
export * from "./premium-reward.vue?vue&type=script&lang=ts"

import "./premium-reward.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__